export default __webpack_public_path__ + "3b249400da2441995b01e5cad075011a.png";